import { toggleAttributeBoolean } from '@utils';

class Accordion extends HTMLElement {
  #collapsibleElements = this.querySelectorAll('collapsible-element');

  connectedCallback() {
    this.addEventListener('click', (event) => this.#closeCollapsibleElements(event));
  }

  /**
   * Close all collapsible elements except the current one
   * @param {Event} event - The event object
   * @param {HTMLElement} event.target - The target element
   */
  #closeCollapsibleElements({ target }) {
    const currentCollapsible = target.closest('collapsible-element');

    this.#collapsibleElements.forEach((collapsible) => {
      if (collapsible === currentCollapsible) return;

      const controller = collapsible.querySelector('[aria-controls]');
      const target = controller.ariaControlsElements[0];

      toggleAttributeBoolean(controller, 'aria-expanded', 'false');
      toggleAttributeBoolean(target, 'aria-hidden', 'true');
    });
  }
}

customElements.define('accordion-element', Accordion);
